export enum ProfitableVsUnprofitableIpoTypeColumnValue {
  Profitable = 'Profitable',
  Unprofitable = 'Unprofitable',
  Total = 'Total',
}
